import api from '../_api'
import {
    FETCH_OPEN_API_KEY_STATUS_REQUEST,
    FETCH_OPEN_API_KEY_STATUS_SUCCESS,
    FETCH_OPEN_API_KEY_STATUS_FAILED,
    CREATE_OPEN_API_KEY_REQUEST,
    CREATE_OPEN_API_KEY_SUCCESS,
    CREATE_OPEN_API_KEY_FAILED,
    DELETE_OPEN_API_KEY_REQUEST,
    DELETE_OPEN_API_KEY_SUCCESS,
    DELETE_OPEN_API_KEY_FAILED,
    UPDATE_SYNC_ACCOUNT_REQUEST,
    UPDATE_SYNC_ACCOUNT_SUCCESS,
    UPDATE_SYNC_ACCOUNT_FAILED,
    UPDATE_PERIOD_EXTENSION_REQUEST,
    UPDATE_PERIOD_EXTENSION_SUCCESS,
    UPDATE_PERIOD_EXTENSION_FAILED,
    FETCH_OPEN_API_LATEST_MONTH_USAGE_REQUEST,
    FETCH_OPEN_API_LATEST_MONTH_USAGE_SUCCESS,
    FETCH_OPEN_API_LATEST_MONTH_USAGE_FAILED,
    FETCH_OPEN_API_DAILY_USAGE_REQUEST,
    FETCH_OPEN_API_DAILY_USAGE_SUCCESS,
    FETCH_OPEN_API_DAILY_USAGE_FAILED
} from './mutation-type'

const getOpenApiKeyStatus = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_OPEN_API_KEY_STATUS_REQUEST)
    try {
        const { data } = await api.fetchOpenApiKeyStatus(rootGetters.requiredService)
        commit(FETCH_OPEN_API_KEY_STATUS_SUCCESS, { data: data.data })
        return data
    } catch (error) {
        commit(FETCH_OPEN_API_KEY_STATUS_FAILED, error)
        throw error
    }
}

const createOpenApiKey = async ({ commit, state, getters, rootGetters }) => {
    commit(CREATE_OPEN_API_KEY_REQUEST)
    try {
        const { data } = await api.createOpenApiKey(rootGetters.requiredService)
        commit(CREATE_OPEN_API_KEY_SUCCESS, { data })
        return data
    } catch (error) {
        commit(CREATE_OPEN_API_KEY_FAILED, error)
        throw error
    }
}

const deleteOpenApiKey = async ({ commit, state, getters, rootGetters }) => {
    commit(DELETE_OPEN_API_KEY_REQUEST)
    try {
        const { data } = await api.deleteOpenApiKey(rootGetters.requiredService)
        commit(DELETE_OPEN_API_KEY_SUCCESS, { data })
        return data
    } catch (error) {
        commit(DELETE_OPEN_API_KEY_FAILED, error)
        throw error
    }
}

const updateSyncAccount = async ({ commit, state, getters, rootGetters }) => {
    commit(UPDATE_SYNC_ACCOUNT_REQUEST)
    try {
        const { data } = await api.updateSyncAccount(rootGetters.requiredService)
        commit(UPDATE_SYNC_ACCOUNT_SUCCESS, { data })
        return data
    } catch (error) {
        commit(UPDATE_SYNC_ACCOUNT_FAILED, error)
        throw error
    }
}

const updatePeriodExtension = async ({ commit, state, getters, rootGetters }) => {
    commit(UPDATE_PERIOD_EXTENSION_REQUEST)
    try {
        const { data } = await api.updatePeriodExtension(rootGetters.requiredService)
        commit(UPDATE_PERIOD_EXTENSION_SUCCESS, { data })
        return data
    } catch (error) {
        commit(UPDATE_PERIOD_EXTENSION_FAILED, error)
        throw error
    }
}

const fetchOpenApiLatestMonthUsage = async ({ commit, state, getters, rootGetters }, { userIdx }) => {
    commit(FETCH_OPEN_API_LATEST_MONTH_USAGE_REQUEST)
    try {
        const { data } = await api.fetchOpenApiLatestMonthUsage(rootGetters.requiredService, { userIdx })
        commit(FETCH_OPEN_API_LATEST_MONTH_USAGE_SUCCESS, { data })
    } catch (error) {
        commit(FETCH_OPEN_API_LATEST_MONTH_USAGE_FAILED, error)
    }
}

const fetchOpenApiDailyUsage = async ({ commit, state, getters, rootGetters }, { userIdx, month }) => {
    commit(FETCH_OPEN_API_DAILY_USAGE_REQUEST)
    try {
        const { data } = await api.fetchOpenApiDailyUsage(rootGetters.requiredService, { userIdx, month })
        commit(FETCH_OPEN_API_DAILY_USAGE_SUCCESS, { data })
    } catch (error) {
        commit(FETCH_OPEN_API_DAILY_USAGE_FAILED, error)
    }
}

export default {
    getOpenApiKeyStatus,
    createOpenApiKey,
    deleteOpenApiKey,
    updateSyncAccount,
    updatePeriodExtension,
    fetchOpenApiLatestMonthUsage,
    fetchOpenApiDailyUsage
}
